function ColorApp() {
  return {
    themeColor: getComputedStyle(document.body).getPropertyValue("--bs-theme").trim(),
    themeFont: getComputedStyle(document.body).getPropertyValue("--bs-body-font-family").trim(),
    themeFontWeight: getComputedStyle(document.body).getPropertyValue("--bs-body-font-weight").trim(),
    gray300: getComputedStyle(document.body).getPropertyValue("--bs-gray-300").trim(),
    orange: getComputedStyle(document.body).getPropertyValue("--bs-warning").trim(),
    inverse: getComputedStyle(document.body).getPropertyValue("--bs-inverse").trim(),
    inverseRgb: getComputedStyle(document.body).getPropertyValue("--bs-inverse-rgb").trim(),
    borderColor: getComputedStyle(document.body).getPropertyValue("--bs-border-color").trim(),
  };
}
export default ColorApp;
